<template>
  <div>
    <h4 class="text-info">{{ order.client.phone }}</h4>
    <client-detail
      v-if="!loading"
      :changeItem="false"
      :fieldList="fieldList"
      @input="send"
      :id="order['client']['id']"
      button_key="next_step"
    ></client-detail>
    <h5 v-else>Ожидайте...</h5>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import ClientDetail from "@/components/Partners/ClientDetail";
export default {
  components: {
    ClientDetail,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  data() {
    return {
      loading: false,
      fieldList: [
        {
          col: " col-12 col-md-12",
          key: "passport_number",
          labelKey: "passport_number",
          label: "Номер паспорта",
          type: "field",
          textType: "text",
        },
      ],
    };
  },
  methods: {
    next() {
      this.save();
    },
    async send(val) {
      this.$loading(true);
      this.loading = true;
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      const data = {
        phone: this.order.client.phone.replace("+", ""),
        passport_id: val.passport_number,
      };

      this.$http
        .post(
          `${partner["endpoint_url"]}clients/clients/create/request`,
          data,
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then(async (response) => {
          if (response.data) {
            if (!response.data.id) {
              this.$emit("setStep", "client-verify");
              this.$emit("input", data);
            } else if (response.data.id) {
              this.$loading(true);
              await this.createTransaction({
                exchange_additional_id: response.data.id,
              });
              this.$loading(false);
              this.$emit("setStep", "client-detail");
              this.$emit("input", response.data);
            }
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
          this.loading = false;
        });
    },
  },
};
</script>